var $989ef7aae85fac12$exports = {};
$989ef7aae85fac12$exports = {
    "breadcrumbs": `\u{41D}\u{430}\u{432}\u{438}\u{433}\u{430}\u{446}\u{438}\u{44F}`
};


export {$989ef7aae85fac12$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
